// Module: modelVersionsEnvelope.js
// Purpose: The ONE unwrap for the SM models-list envelope {status, data: {versions, instrument_lookup_degraded}} (142-9 A-1).
//          Shared by the Admin Models page and the Builder ModelVersionSelect picker. Pure (no axios) so tests keep it real.

// The SM envelope's payload (list, detail and references all share {status, data, error}).
export function unwrapModelPayload(response) {
  return response?.data?.data ?? response?.data ?? {};
}

export function unwrapModelVersions(response) {
  const payload = unwrapModelPayload(response);
  return {
    versions: Array.isArray(payload.versions) ? payload.versions : [],
    instrumentLookupDegraded: payload.instrument_lookup_degraded === true,
  };
}
